module.exports = __webpack_public_path__ + "img/StorageByItem-min.d28cc6e0.png";